import React from "react"
import useGoogleSheets from "use-google-sheets"
import config from "../../../firebaseConfig"
import ReactPlayer from "react-player"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import { recordEvent } from "../../apis/googleAnalytics"

const BibleEffectVideo = ({ language, version, book, setShowRR }) => {
  const { data, loading, error } = useGoogleSheets({
    apiKey: "AIzaSyAb_P06-faYkzrsHqYvF7us6kBdfyIpY6M",
    sheetId: "1_NIVQ4R_Q9WdcZMbWAYGBvaDIF8z3zGEPYNtv-rF8Ms",
    sheetsNames: [language],
  })

  if (loading) {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          textAlign: "center",
        }}
      >
        <LoadingSpinner />
      </div>
    )
  }

  if (error) {
    return null;
  }

  const books = data[0].data
  const url = books.find(b => b["SVB BookID"] === book)["YouTube URL"]

  if (!url) return null;
  setShowRR(true)
  return (
    <div
      style={{
        margin: "10px 0 100px 0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ReactPlayer
        url={url}
        controls
        onStart={() =>
          recordEvent(
            "Start Bible Effect Video",
            `${language}-${version}`,
            book
          )
        }
      />
    </div>
  )
}

export default BibleEffectVideo